const translations = {
    confirm: 'Confirm',
    warning: 'Are you sure you want to leave? Any unsaved progress will be lost.'
};

export default translations;
